/* PagingDeviceFeed.js */

const PagingFeed = require("../../../../../../lib/PagingFeed");

class PagingDeviceFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startDevicesFeed(this._activeOrgId, this._filter, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
    }

    _getDistinctValuesOfField(tenantId, field) {
        return this._EntityDef.startDeviceDistinctValuesFeed(tenantId, field);
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadDeviceIdsForSelection(tenantId, selection);
    }

    getDeviceEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getDeviceEntitiesNameById(ids) {
        return this.getEntitiesNameById(ids);
    }

    getDeviceEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingDeviceFeed;
